import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { deleteOrderConfirmation, listOrderConfirmations } from "../ordersApi";

export const useOrderConfirmations = (orderId: string) => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery({
    queryKey: ["orders", orderId, "confirmations"],
    queryFn: ({ signal }) => listOrderConfirmations(orderId, signal),
  });

  useEffect(() => {
    if (!isLoading && error) {
      enqueueSnackbar(`Nie udało się pobrać potwierdzeń. Powód: ${error.message}`, {
        variant: "error",
      });
    }
  }, [error, isLoading]);

  const deleteConfirmationMutation = useMutation<void, unknown, { confirmationId: string }>({
    mutationFn: ({ confirmationId }) => deleteOrderConfirmation(orderId, confirmationId),
    onSuccess: async () => {
      enqueueSnackbar("Potwierdzenie zamówienia zostało usunięte", { variant: "success" });
      await queryClient.invalidateQueries({ queryKey: ["orders", orderId, "confirmations"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się usunać potwierdzenia. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });

  return {
    confirmations: data ?? [],
    isLoading,
    deleteConfirmation: (confirmationId: string) => deleteConfirmationMutation.mutateAsync({ confirmationId }),
  };
};
